import React from "react";
import { useApp, t } from "@/lib/AppContext";
import { resolveImg } from "@/lib/api";
import SectionLabel from "@/components/SectionLabel";

export default function About() {
  const { content, settings } = useApp();
  const bg = settings?.bg_image_urls?.about;
  return (
    <div data-testid="about-page">
      <section className="relative py-20 md:py-32 section-on-dark">
        <div className="absolute inset-0">
          {bg && <img src={resolveImg(bg)} alt="" className="w-full h-full object-cover" />}
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(28,58,107,0.78) 0%, rgba(15,36,68,0.92) 100%)" }} />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-white text-center">
          <SectionLabel light>{t(content, "about.label", "О нас")}</SectionLabel>
          <h1 className="hero-title mt-4 text-3xl md:text-5xl">{t(content, "about.title", "")}</h1>
          <p className="font-accent text-lg md:text-2xl mt-6 italic" style={{ color: "var(--color-gold)" }}>«{t(content, "about.quote", "")}»</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-lg text-[var(--color-text-primary)] leading-relaxed mb-12">{t(content, "about.text", "")}</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-12">
            {[
              { num: t(content, "stats.stat1_num", "7+"), label: t(content, "stats.stat1_label", "лет на рынке") },
              { num: t(content, "stats.stat2_num", "300+"), label: t(content, "stats.stat2_label", "авто доставлено") },
              { num: t(content, "stats.stat3_num", "98%"), label: t(content, "stats.stat3_label", "довольных клиентов") },
            ].map((s, i) => (
              <div key={i} className="p-6 rounded-[var(--radius-lg)] text-center border" style={{ borderColor: "var(--color-border)" }}>
                <div className="stat-number">{s.num}</div>
                <div className="font-accent text-sm uppercase tracking-wider text-[var(--color-text-secondary)] mt-2">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
